export const selectIsFetchingOrganization = ({ organizations }) =>
  organizations?.ui?.isFetchingOrganization || false;
export const selectIsFetchingOrganizations = ({ organizations }) =>
  organizations?.ui?.isFetchingOrganizations || false;
